export enum UserPermission {
    IndexView = 'synergy.admin.index.view',
    Index = 'synergy.admin.index',
    IndexAdd = 'synergy.admin.index.add',
    IndexEdit = 'synergy.admin.index.edit',
    IndexDelete = 'synergy.admin.index.delete',
    IndexSecurity = 'synergy.admin.index.security',
    DashBoardView = 'synergy.admin.dashboard.view',
    DashBoard = 'synergy.admin.dashboard',
    DashBoardAdd = 'synergy.admin.dashboard.add',
    DashBoardEdit = 'synergy.admin.dashboard.edit',
    DashBoardDelete = 'synergy.admin.dashboard.delete',
    DashBoardSecurity = 'synergy.admin.dashboard.security',
    SalesOrdersView = 'synergy.admin.salesOrders.view',
    SalesOrders = 'synergy.admin.salesOrders',
    SalesOrdersAdd = 'synergy.admin.salesOrders.add',
    SalesOrdersEdit = 'synergy.admin.salesOrders.edit',
    SalesOrdersDelete = 'synergy.admin.salesOrders.delete',
    SalesOrdersSecurity = 'synergy.admin.salesOrders.security',
    PurchaseOrdersView = 'synergy.admin.purchaseOrders.view',
    PurchaseOrders = 'synergy.admin.purchaseOrders',
    PurchaseOrdersAdd = 'synergy.admin.purchaseOrders.add',
    PurchaseOrdersEdit = 'synergy.admin.purchaseOrders.edit',
    PurchaseOrdersDelete = 'synergy.admin.purchaseOrders.delete',
    PurchaseOrdersSecurity = 'synergy.admin.purchaseOrders.security',
    DemandsView = 'synergy.admin.demands.view',
    Demands = 'synergy.admin.demands',
    DemandsAdd = 'synergy.admin.demands.add',
    DemandsEdit = 'synergy.admin.demands.edit',
    DemandsDelete = 'synergy.admin.demands.delete',
    DemandsSecurity = 'synergy.admin.demands.security',
    InquiriesView = 'synergy.admin.inquiries.view',
    Inquiries = 'synergy.admin.inquiries',
    InquiriesAdd = 'synergy.admin.inquiries.add',
    InquiriesEdit = 'synergy.admin.inquiries.edit',
    InquiriesDelete = 'synergy.admin.inquiries.delete',
    InquiriesSecurity = 'synergy.admin.inquiries.security',
    InvoicesView = 'synergy.admin.invoices.view',
    Invoices = 'synergy.admin.invoices',
    InvoicesAdd = 'synergy.admin.invoices.add',
    InvoicesEdit = 'synergy.admin.invoices.edit',
    InvoicesDelete = 'synergy.admin.invoices.delete',
    InvoicesSecurity = 'synergy.admin.invoices.security',
}
